<template lang="pug">
.subscription.mt-4
   loader(:showLoader="loader")
   .flex(class="flex-col lg:flex-row text-white" v-if="!activeSubscription")
      .sub-box
         span.text-5xl $ 5
         p.text-3xl.my-4 Monthly
         ul.list-reset
            li.mt-1 Unlimited Websites
            li.mt-1 Realtime stats update every 5s
            li.mt-1 1 year subscription
            li.mt-1 17 cent / day
         subscribe-btn.btn-primary.mt-8(subscription="gooticsMonthly" :fetchStatus="fetchSubStatus")
      .sub-box.sub-box-hover
         span.text-5xl $ 29
         p.text-3xl.my-4 Yearly
         ul.list-reset
            li.mt-1 Unlimited Websites
            li.mt-1 Realtime stats update every 5s
            li.mt-1 1 year subscription
            li.mt-1 8 cent / day
         subscribe-btn.btn-primary.mt-8(subscription="gooticsYearly" :fetchStatus="fetchSubStatus")
      .sub-box
         span.text-5xl $ 89
         p.text-3xl.my-4 Lifetime
         ul.list-reset
            li.mt-1 Unlimited Websites
            li.mt-1 Realtime stats update every 5s
            li.mt-1 One time payment
            li.mt-1 Lifetime access
         subscribe-btn.btn-primary.mt-8(subscription="gooticsLifetime" :fetchStatus="fetchSubStatus")
   .flex(class="flex-col lg:flex-row text-white" v-if="!activeSubscription")
      .sub-box.flex-grow.border-none
         span.text-5xl Free
         ul.list-reset
            li.mt-1 2 Websites
            li.mt-1 Realtime stats update every 30s
   .flex(v-else)
      .container.mx-auto.text-left.text-white.leading-normal.max-w-md.mb-8.mt-4
         h2 Subscription Details
         p.mt-2
            b Subscription:
            |  {{subscription.planName}}
         p
            b Status:
            |  {{subscription.status}}
         p
            b(v-if="!subscription.canceled") Period ends:
            b(v-else) Cancelled for:
            |  {{subscription.ending | moment("YYYY-MM-DD HH:mm:ss")}}
         p.mt-2(v-if="!subscription.canceled && subscription.ending != 'never'")
            i The subscription will be renewed automatically. ☺️
         p.mt-2(v-if="subscription.ending == 'never'")
            i The subscription will be valid for a lifetime. ☺️
         p.mt-2(v-if="subscription.ending != 'never' && !subscription.canceled")
          button.btn.btn-default.text-red(@click="delModal()") Cancel subscription
   modal(:show="modal"  :delSub="delSub"  :hideModal="hideModal")
</template>

<script>
import axios from 'axios'
import SubscribeBtn from '@/components/modules/SubscribeBtn'
import Loader from '@/components/modules/Loader'
import Modal from '@/components/modules/ModalDel'

export default {
  components: {
    SubscribeBtn,
    Modal,
    Loader
  },
  created () {
    this.fetchSubStatus()
  },
  data () {
    return {
      loader: false,
      modal: false,
      activeSubscription: false,
      subscription: {}
    }
  },
  methods: {
    fetchSubStatus () {
      console.log('fetch sub status')
      this.loader = true
      axios.get(`subscription/substatus`).then((res) => {
        if (res.status === 200 && res.data.status === 'active') {
          console.log(res.data)
          localStorage.setItem('subscription', JSON.stringify(res.data))
          this.subscription = res.data
          this.activeSubscription = true
        }
        this.loader = false
      }).catch(err => {
        console.log(err)
        this.loader = false
      })
    },
    delModal () {
      this.modal = true
    },
    hideModal () {
      this.modal = false
    },
    delSub () {
      console.log('delete subs')
      this.modal = false
      this.loader = true
      axios.get(`subscription/delete`).then((res) => {
        if (res.status === 200 && res.data.status === 'active') {
          console.log(res.data)
          this.fetchSubStatus()
        }
        this.loader = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Subscription.vue